const aboutButton = document.querySelector('.about__offer__tag__button');

if (aboutButton) {
    aboutButton.addEventListener('click', () => {
        document.querySelector('.about__offer__tag').classList.toggle('active');
    });
}